/**
 * Provides JS functionality for tracking alert display.
 */
class RecentNews extends DrupalBehavior {

  onReady(document) {
    $('.recent-news').each(function () {
      $element = $(this);
      $wrapper = $element.find('.recent-news__news-wrapper');
      $buttons = $element.find('.recent-news__buttons a');
      $query = drupalSettings.breakpoints['camc_camc.md'].query;
      const checkMatch = (size) => {
        if (size.matches) {
          if ($wrapper.hasClass('slick-initialized')) {
            $wrapper.slick('unslick');
          }
          $buttons.addClass('btn-underline--lg');
        } else {
          $wrapper.slick({
            appendArrows: $wrapper.siblings('.recent-news__controls'),
          });
          $buttons.removeClass('btn-underline--lg');
        }
      };
      var x = window.matchMedia($query);
      checkMatch(x);
      x.addListener(checkMatch);
    });
  }

}

DrupalBehavior.register('camc_news', 'recentnews', RecentNews);
